import { reactive } from 'vue';

const state = reactive({
  locale: 'ar', 
});

const setLocale = (newLocale) => {
  state.locale = newLocale;
};

export default {
  state,
  setLocale,
};
